import React from 'react';
import T from 'prop-types';

import Button from '../../../Buttons/Button';

const FormActions = ({
  isSubmitDisabled = false,
  onSubmit,
}) => (
  <Button
    disabled={isSubmitDisabled}
    onClick={onSubmit}
  >
    Generate Export
  </Button>
);

FormActions.propTypes = {
  isSubmitDisabled: T.bool,
  onSubmit: T.func.isRequired,
};

export default FormActions;
